module.exports = __webpack_public_path__ + "static/media/jupiter-1.3e27a8b6.jpg";